import {
  FETCH_CUSTOMERS_DATA,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
} from "./actionTypes";

/**
 * @param {Object} params
 * @param {number} [params.page=1] - Page number (1-based)
 * @param {number} [params.limit=10] - Items per page
 */
export const fetchCustomersData = (params = {}) => ({
  type: FETCH_CUSTOMERS_DATA,
  payload: {
    page: params.page ?? 1,
    limit: params.limit ?? 10,
  },
});

export const fetchCustomersSuccess = (data) => ({
  type: FETCH_CUSTOMERS_SUCCESS,
  payload: data,
});

export const fetchCustomersFailure = (error) => ({
  type: FETCH_CUSTOMERS_FAILURE,
  payload: error,
});
